import { PencilSimple, Check, X, Trash } from "@phosphor-icons/react";

const EditCells = ({ fields, testPrefix, editForm, setEditForm, itemId, save, setEditId }) => (
  <>
    {fields.map((f) => (
      <td key={f.key} className="p-2">
        {f.type === "select" ? (
          <select data-testid={`${testPrefix}-edit-${f.key}-input`} value={editForm[f.key] || ""}
            onChange={(e) => setEditForm((p) => ({ ...p, [f.key]: e.target.value }))}
            className="w-full rounded-md border border-slate-300 bg-white px-1 py-1.5 text-sm outline-none">
            <option value="">—</option>
            {f.options.map(([v, label]) => <option key={v} value={v}>{label}</option>)}
          </select>
        ) : (
          <input data-testid={`${testPrefix}-edit-${f.key}-input`} value={editForm[f.key] || ""}
            onChange={(e) => setEditForm((p) => ({ ...p, [f.key]: e.target.value }))}
            className="w-full rounded-md border border-slate-300 px-2 py-1.5 text-sm outline-none focus:border-slate-900" />
        )}
      </td>
    ))}
    <td className="p-2 text-right">
      <div className="flex items-center justify-end gap-2">
        <button data-testid={`${testPrefix}-save-edit-button`} onClick={() => save(itemId)}
          className="text-emerald-600 transition-colors duration-150 hover:text-emerald-800"><Check size={16} weight="bold" /></button>
        <button onClick={() => setEditId(null)}
          className="text-slate-400 transition-colors duration-150 hover:text-slate-700"><X size={16} /></button>
      </div>
    </td>
  </>
);

const DisplayCells = ({ item, fields, testPrefix, setEditId, setEditForm, remove }) => (
  <>
    {fields.map((f) => (
      <td key={f.key} className="p-3 font-medium">
        {f.type === "select"
          ? (f.options.find(([v]) => v === item[f.key])?.[1] || <span className="text-slate-300">—</span>)
          : (item[f.key] || <span className="text-slate-300">—</span>)}
      </td>
    ))}
    <td className="p-3 text-right">
      <div className="flex items-center justify-end gap-3">
        <button data-testid={`${testPrefix}-edit-button-${item.name}`}
          onClick={() => { setEditId(item.id); setEditForm(item); }}
          className="text-slate-400 transition-colors duration-150 hover:text-slate-900"><PencilSimple size={16} weight="duotone" /></button>
        <button data-testid={`${testPrefix}-delete-button-${item.name}`} onClick={() => remove(item)}
          className="text-slate-400 transition-colors duration-150 hover:text-red-600"><Trash size={16} weight="duotone" /></button>
      </div>
    </td>
  </>
);

export function MasterRow({ item, fields, bulk, testPrefix, selected, setSelected, isEditing, setEditId, editForm, setEditForm, save, remove }) {
  return (
    <tr className="border-b border-slate-100 transition-colors duration-150 hover:bg-slate-50">
      {bulk && (
        <td className="w-10 p-3">
          <input type="checkbox" data-testid={`${testPrefix}-select-${item.name}`}
            checked={selected.includes(item.id)}
            onChange={() => setSelected((p) => (p.includes(item.id) ? p.filter((x) => x !== item.id) : [...p, item.id]))}
            className="h-4 w-4 accent-slate-900" />
        </td>
      )}
      {isEditing ? (
        <EditCells fields={fields} testPrefix={testPrefix} editForm={editForm} setEditForm={setEditForm}
          itemId={item.id} save={save} setEditId={setEditId} />
      ) : (
        <DisplayCells item={item} fields={fields} testPrefix={testPrefix}
          setEditId={setEditId} setEditForm={setEditForm} remove={remove} />
      )}
    </tr>
  );
}
